import { Tooltip, Box, Text, Stack } from '@chakra-ui/react';
import { UilPlus } from '@iconscout/react-unicons';
import { UilTrashAlt } from '@iconscout/react-unicons';
import { UilEdit } from '@iconscout/react-unicons';
import { useSelector, useDispatch } from 'react-redux';
import { selectPage, selectedPage } from '../../redux/selectedPageSlice';
import { removePage } from '../../redux/pagesSlice';

// páginas q devem sempre existir e não podem ser excluídas (home,header etc)
const defaultPageTypes = [
	'home',
	'header',
	'footer',
	'product',
	'search',
	'shelf',
	'breadcrumb',
	'search-not-found',
	'minicart',
	'modal-newsletter',
	'store-menu',
];

function openEditPopover({ setEditPage, page, e }) {
	e.stopPropagation();
	setEditPage(
		page
			? page
			: {
					pageType: '',
				},
	);
}

function selectPageHandle({ page, setEditPage, dispatch, onToggle }) {
	window.location.hash = page.pageId;
	dispatch(selectPage(page.pageId));
	setEditPage(false);
	onToggle();
}

function removePageHandler({ page, setEditPage, selectedPageValue, dispatch, e }) {
	e.stopPropagation();
	if (!page) return;
	if (page.pageId == 'default-1') {
		return;
	}
	const pageIdToDelete = page.pageId;
	if (selectedPageValue == pageIdToDelete) {
		window.location.hash = 'default-1';
		dispatch(selectPage('default-1'));
	}

	dispatch(removePage(pageIdToDelete));
	setEditPage(false);
}

const PageSelectorLines = ({ page, setEditPage, isSelected, onToggle }) => {
	// const [pages, setPages] = React.useContext(CanvasContext);
	const selectedPageValue = useSelector(selectedPage);
	const dispatch = useDispatch();

	return !!page === false ? (
		<Box
			onClick={(e) => openEditPopover({ setEditPage, page, e })}
			d="flex"
			py={2}
			margin="0 auto"
			w={'100%'}
			border="2px dashed"
			_hover={{ border: '2px dashed #ECC94B', color: '#ECC94B' }}
			placeContent={'center'}
			alignItems={'center'}
			transition={'0.1s'}
			cursor="pointer"
			flex="1 0 10px"
			flexDirection="row"
			borderWidth="2px"
			borderRadius="lg"
		>
			<Text fontWeight={'700'} fontSize={'sm'} mr={2}>
				Nova Página
			</Text>
			<UilPlus size="16px" />
		</Box>
	) : (
		<Box
			onClick={() => {
				selectPageHandle({ page, setEditPage, dispatch, onToggle });
			}}
			borderStyle={'solid'}
			borderWidth={isSelected ? '2px' : '1px'}
			borderColor={isSelected ? 'yellow.400' : ''}
			d="flex"
			py={1}
			margin="0 auto"
			w={'100%'}
			_hover={{ boxShadow: '0 0 2px 1pt #ECC94B' }}
			placeContent={'center'}
			justifyContent={'space-between'}
			alignItems={'center'}
			transition={'0.1s'}
			cursor="pointer"
			flex="1 0 10px"
			flexDirection="row"
			borderRadius="lg"
		>
			<Tooltip hasArrow label={page.pageName} aria-label="Nome da página">
				<Text px={3} isTruncated flexBasis={'70%'} fontSize={'sm'}>
					{page.pageName}
				</Text>
			</Tooltip>
			<Text fontSize={'xs'} isTruncated color={'gray.500'} flexBasis={'20%'}>
				{page.pageType}
			</Text>
			<Stack direction={'row'} pr={3}>
				<Box onClick={(e) => openEditPopover({ setEditPage, page, e })} _hover={{ svg: { fill: 'yellow.400' } }}>
					<UilEdit />
				</Box>
				{!defaultPageTypes.includes(page.pageType) || page.pageType == 'custom' ? (
					<Box
						onClick={(e) => removePageHandler({ page, setEditPage, selectedPageValue, dispatch, e })}
						_hover={{ svg: { fill: 'yellow.400' } }}
					>
						<UilTrashAlt />
					</Box>
				) : (
					<Box w={'24px'} h={'24px'}>
						{/* apenas filler para o layout se manter correto */}
					</Box>
				)}
			</Stack>
		</Box>
	);
};

export default PageSelectorLines;
